/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { addZeroes } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  FAILED_MESSAGE_GENERIC,
  NO_RESULT_FOUND_ERROR,
} from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchFilterSearch = (data) => ({
  type: actionTypes.FILTER_SEARCH,
  filterValue: data,
});

export const selectionList = (data) => {
  return {
    type: actionTypes.GET_EXITING_ROW,
    payload: data,
  };
};
export const selectByList = () => {
  return {
    type: actionTypes.SELECT_BY_OPTIONS,
    payload: [],
  };
};
export const searchTypeList = () => {
  return {
    type: actionTypes.SEARCH_TYPE_OPTIONS,
    payload: [],
  };
};
export const dispatchBottonState = (data) => {
  return {
    type: actionTypes.BUTTON_STATE,
    payload: data,
  };
};
export const SearchScreenRedux1 = (data) => ({
  type: actionTypes.SEARCH_REDUX1,
  payload: data,
});

export const SearchScreenRedux = (data) => ({
  type: actionTypes.SEARCH_REDUX,
  payload: data,
});
export const handleErrorMessages = (data) => {
  return {
    type: actionTypes.HANDLE_ERROR_MESSAGE_FOR_UC,
    errorMessagesInRedux: data,
  };
};
export const handleErrorMessagesClear = (data) => {
  return {
    type: actionTypes.HANDLE_ERROR_MESSAGE_FOR_UC,
    errorMessagesInRedux: data,
  };
};
export const setMfgSelected = (data) => {
  return {
    type: actionTypes.MFG_SELECTED,
    mfgSelected: data,
  };
};

export const dispatchSelectedNDCSearch = (data) => ({
  type: actionTypes.SEARCH_SELECTED_NDC,
  selectedNdcSearch: data,
});

export const dispatchSelectedNDCs = (data) => ({
  type: actionTypes.SELECTED_NDC_LIST,
  ndcList: data,
});
export const dispatchGetNDCByMfgId = (data) => ({
  type: actionTypes.GET_NDC_MFG_ID,
  payLoad: data,
});
export const dispatchGetSingleNDCByMfgId = (data) => ({
  type: actionTypes.GET_SINGLE_NDC_MFG_ID,
  payLoad: data,
});

export const dispatchShowUnitConversion = (data) => ({
  type: actionTypes.SHOW_CONVERSION_LIST,
  showUCList: data,
});

export const dispatchUpdatedTempNDCs = (data) => ({
  type: actionTypes.UPDATED_TEMP_NDC,
  ndcTempList: data,
});

export const dispatchDeletedConvList = (data) => ({
  type: actionTypes.DELETED_NDC,
  deleteConvList: data,
});

export const dispatchAddedNewNdc = (data) => ({
  type: actionTypes.ADDED_NDC,
  addNewNdc: data,
});

export const dispatchAllNDCs = (data) => ({
  type: actionTypes.GET_ALL_UC_NDC,
  ndcListForUC: data,
});

export const dispatchAllManufacturerList = (data) => ({
  type: actionTypes.GET_ALL_UC_MANUFACTURER_LIST,
  allManufacturer: data,
});

export const dispatchAllExistingRows = (data) => ({
  type: actionTypes.GET_ALL_UC_EXISTING_ROWS,
  existingRows: data,
});

export const dispatchAlllabelerList = (data) => ({
  type: actionTypes.GET_ALL_UC_LABELER_LIST,
  labelerList: data,
});

export const dispatchAllNDCForLabeller = (data) => ({
  type: actionTypes.GET_UC_NDC_BY_LABELLER,
  ndcListFromLabeller: data,
});

export const dispatchAllRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_REBATE_DROPDOWN,
    rebateProgramCode: data,
  };
};

export const dispatchUpdatedTable = (data) => {
  return {
    type: actionTypes.UPDATED_TABLE,
    updatedTable: data,
  };
};

export const dispatchAllClaimDrop = (data) => {
  return {
    type: actionTypes.GET_ALL_CLAIM_DROPDOWN,
    claimCode: data,
  };
};
export const dispatchNdcGrid = (data) => ({
  type: actionTypes.GET_NDC_GRID_DATA,
  payLoad: data,
});

//  error msg dispatch function
export const dispatchErrorMsg = (data) => ({
  type: actionTypes.ERROR_MESSAGES_UC,
  payload: data,
});

export const dispatchFirstTimeAdd = (data) => ({
  type: actionTypes.FIRST_TIME_ADD,
  payload: data,
});

export const getAllManufacturerList = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_UC_MANUFACTURER, values)
    .then((response) => {
      dispatch(dispatchAllManufacturerList(response.data));
    })
    .catch(() => {
      dispatch(dispatchAllManufacturerList({ error: 'API failed' }));
    });
};
export const getNdcGrid = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_NDC_GRID, values)
    .then((response) => {
      let tempObj = [];
      if (response?.data?.data && response?.data?.data?.length > 0) {
        tempObj = response?.data?.data.map((item, index) => {
          item.indexNumber = index;
          item.billedUnitFactor = item.billedUnitFactor
            ? addZeroes(item.billedUnitFactor.toString())
            : addZeroes(item.billedUnitFactor.toString());
          item.cmsUnitFactor = item.cmsUnitFactor
            ? addZeroes(item.cmsUnitFactor.toString())
            : addZeroes(item.billedUnitFactor.toString());
          item.disableBit = !(
            item.ucClaimCategoryCD === 'MD' || item.ucClaimCategoryCD === 'MN'
          );
          return item;
        });
      }
      return dispatch(dispatchNdcGrid(tempObj));
    })
    .catch(() => {
      dispatch(dispatchNdcGrid({ error: 'API failed' }));
    });
};

export const navigateToUnitConversion = (
  filter,
  onSuccess = () => {},
  onError = () => {}
) => {
  return async (dispatch) => {
    try {
      localStorage.setItem('ndc-val', JSON.stringify(filter));

      const response = await axios.post(
        serviceEndPoint.GET_UNIT_CONVERSION_DETAIL,
        filter
      );

      if (response.data) {
        if (
          response.data.data &&
          response.data.data[0] &&
          response.data.data[0].unitConversionGridVO &&
          response.data.data[0].unitConversionGridVO.length === 0
        ) {
          localStorage.setItem('checkSearchBit', 10);
        } else {
          if (localStorage.getItem('checkSearchBit') === 10) {
            localStorage.setItem('selectionChanged', true);
          } else {
            localStorage.setItem('selectionChanged', false);
          }
          localStorage.setItem('checkSearchBit', 11);
        }

        dispatch(dispatchSelectedNDCs(response.data));
        dispatch(dispatchSelectedNDCSearch(response.data));
        onSuccess();
      } else {
        onError();
      }
    } catch (e) {
      onError();
    }
  };
};

export const getUnitConversionDetail = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_UNIT_CONVERSION_DETAIL, values)
    .then((response) => {
      const temp = response?.data?.data.map((item, index) => {
        item.NDC = `${item.labelerCode}-${item.productCode}-${item.packageSize}`;
        item.indexPaginate = index;
        return item;
      });
      const res = {
        status: '001',
        data: temp,
      };
      dispatch(dispatchGetNDCByMfgId(res));
      dispatch(dispatchGetSingleNDCByMfgId(res.data[0]));
    })
    .catch((error) => {
      dispatch(dispatchGetNDCByMfgId({ error: 'API failed' }));
      dispatch(dispatchGetSingleNDCByMfgId({ error: 'API failed' }));
    });
};

export const getSingleNdcDetail = (values) => (dispatch, cb) => {
  return new Promise((fulfill, reject) => {
    axios
      .post(serviceEndPoint.GET_UNIT_CONVERSION_DETAIL, values)
      .then((response) => {
        if (response.data.data && response.data.data.length > 0) {
          cb(response.data.data);
          fulfill(response.data.data);
        } else {
          cb({ error: 'API failed' });
          fulfill({ error: 'API failed' });
        }
      })
      .catch((error) => {
        cb({ error: 'API failed' });
        reject({ error: 'API failed' });
      });
  });
};

export const getExistingRows = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_NDC_LIST, values)
    .then((response) => {
      dispatch(dispatchAllExistingRows(response.data));
    })
    .catch((error) => {
      dispatch(dispatchAllExistingRows({ error: 'API failed' }));
    });
};
export const getNDCByMfgId = (values, err) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_NDC_BY_MFG_ID, values)
    .then((response) => {
      const temp = response?.data?.data
        .map((item, index) => {
          item.NDC = `${item.labelerCode}-${item.productCode}-${item.packageSize}`;
          // item.indexPaginate = index;
          item.billedUnitFactor = item.billedUnitFactor
            ? addZeroes(item.billedUnitFactor.toString())
            : '';
          item.cmsUnitFactor = item.cmsUnitFactor
            ? addZeroes(item.cmsUnitFactor.toString())
            : '';
          return item;
        })
        ?.sort((a, b) => (a.NDC > b.NDC ? 1 : -1))
        ?.map((item, index) => {
          item.indexPaginate = index;
          return item;
        });
      const res = {
        status: '001',
        data: temp,
      };
      dispatch(dispatchGetNDCByMfgId(res));
      dispatch(
        dispatchGetSingleNDCByMfgId(res.data?.length > 0 ? res?.data[0] : [])
      );
    })
    .catch((error) => {
      // dispatch(dispatchGetNDCByMfgId({ error: 'API failed' }));
      // dispatch(dispatchGetSingleNDCByMfgId({ error: 'API failed' }));
      let message = '';
      if (error?.response?.status === 400) {
        message = NO_RESULT_FOUND_ERROR;
      } else if (error?.response?.status === 500) {
        message = FAILED_MESSAGE_GENERIC;
      }
      if (message)
        dispatch(
          handleErrorMessages({
            searchScreenErrors: [
              { field: 'search', errorType: 'noResults', message: message },
            ],
            detailScreenErrors: err.detailScreenErrors,
          })
        );
    });
};

export const dispatchGetCodeTableDetails = (data) => ({
  type: actionTypes.GET_NDCs_UC_LIST_SEARCH_BY_NAME_OR_NDCs,
  drugsList: data,
});

export const dispatchError = (data) => ({
  type: actionTypes.ERROR_MSG,
  errorMsg: data,
});

export const getNDCsListSearchByNameorNDCs = (values) => (dispatch) => {
  const filter = {
    searchBy: values.searchBy,
    inputValue: values.inputValue,
    page: values.page,
    pageSize: values.pageSize,
  };
  const url = serviceEndPoint.SEARCH_NDC_BY_ID_OR_DRUG_NAME;

  return axios
    .post(url, filter)
    .then((response) => {
      dispatch(dispatchGetCodeTableDetails(response.data));
      return response.data;
    })
    .catch((error) => {
      dispatch(dispatchGetCodeTableDetails({ error: 'API failed' }));
      return null;
    });
};

export const getNDCByLabeller = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_UPDATED_NDC_LIST_BY_LABELER, values)
    .then((response) => {
      dispatch(dispatchAllNDCForLabeller(response.data));
    })
    .catch((error) => {
      dispatch(dispatchAllNDCForLabeller({ error: 'API failed' }));
    });
};

export const dispatchSuccessMessage = (data) => ({
  type: actionTypes.SUCCESS_RESPONSE_DETAIL,
  payLoad: data,
});

export const updateUnitConversionNdc = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_UC_NDC, values)
    .then((response) => {
      return dispatch(dispatchSuccessMessage(response));
    })
    .catch(() => {
      return dispatch(dispatchSuccessMessage({ error: 'API failed' }));
    });
};

export const getLabelerList = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_ALL_LABELER_LIST, values)
    .then((response) => {
      dispatch(dispatchAlllabelerList(response.data));
    })
    .catch((error) => {
      dispatch(dispatchAlllabelerList({ error: 'API failed' }));
    });
};

export const setSearchByDrugNameTableData = (payload) => {
  return {
    type: actionTypes.NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA,
    payload,
  };
};

export const searchNDCByIDORDrugName = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.SEARCH_NDC_BY_ID_OR_DRUG_NAME,
      values
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const getTempUpdatedNdc = (values) => (dispatch, getState) => {
  const arr = [];

  if (values == 0) {
    return dispatch(dispatchUpdatedTempNDCs(values));
  }
  const currentTemp = {
    ...getState().sharedState.UnitConversionReducer.ndcTempList,
  };

  if (currentTemp && Object.keys(currentTemp).length > 0) {
    return dispatch(dispatchUpdatedTempNDCs(values));
  }
  arr.push(values);
  return dispatch(dispatchUpdatedTempNDCs(arr));
};

export const deleteConvList = (values) => (dispatch, getState) => {
  return dispatch(dispatchDeletedConvList(values));
};

export const addConvList = (values) => (dispatch, getState) => {
  return dispatch(dispatchAddedNewNdc(values));
};

export const GetAllRebateDropdown = () => {
  return axios
    .post(serviceEndPoint.GET_ALL_DROPDN_REBATE)
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};

export const GetAllClaimDropdown = (values) => {
  return axios
    .post(serviceEndPoint.DROPDOWNS, values)
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};

export const dispatchViewHistoryforPlan = (values) => {
  return {
    planViewHistory: values,
    type: actionTypes.VIEW_HISTORY,
  };
};

export const viewHistoryPlans = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.VIEW_HISTORY}`, values)
    .then((response) => {
      return dispatch(
        dispatchViewHistoryforPlan(response.data.responseAuditLogDetails)
      );
    })
    .catch((response) => {
      dispatch(dispatchViewHistoryforPlan(response));
    });
};

export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

export const dispatchStatusBit = (values) => {
  return {
    type: actionTypes.STATUS_BIT,
    payload: values,
  };
};
export const setCMSUnitType = (data) => ({
  type: actionTypes.GET_CMS_UNIT_TYPES,
  payload: data,
});
export const clearReduxFirstScreenUnitConversion = () => (dispatch) => {
  dispatch(setMfgSelected({}));
  dispatch(dispatchStatusBit(0));
  dispatch(selectionList(''));
  dispatch(dispatchAllExistingRows({}));
  dispatch(selectByList([]));
  dispatch(SearchScreenRedux({}));
  dispatch(dispatchGetSingleNDCByMfgId({}));
  dispatch(handleErrorMessages([]));
  dispatch(dispatchAllManufacturerList({}));
  dispatch(SearchScreenRedux1({}));
  dispatch(searchTypeList([]));
  dispatch(selectionList([]));
};

export const clearReduxDetailScreenUnitConversion = () => (dispatch) => {
  dispatch(handleErrorMessages([]));
  dispatch(dispatchNdcGrid([]));
  dispatch(dispatchSuccessMessage({}));
  dispatch(deleteConvList([]));
  dispatch(dispatchGetSingleNDCByMfgId({}));
  dispatch(dispatchGetNDCByMfgId({}));
  dispatch(dispatchBottonState(true));
  dispatch(setCMSUnitType({}));
};
